// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#algolia-search {
    position: relative;
}

.search-list {
    display: none;
    background-color: #FFFFFF;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 300px;
    z-index: 100;
    overflow: scroll;
    border: 1px solid #C9D6DE;
    border-top: 0;
    font-size: 14px;
}

.search-list li {
    padding: 8px 10px;
    border-bottom: 1px solid #C9D6DE;
    cursor: pointer;
}

.search-list li:last-child {
    border-bottom: 0;
}

.list-opened {
    display: block;
}

.al-search-list-opened{
    display: block;
    width: 210px;
    z-index: 1000000;
    position: absolute;
    top: 60px;
    left: 52px;
}

.firebase-suppliers-view {
    margin-top: 50px;
    min-height: 300px;
}

.firebase-suppliers-view-two {
    margin-top: 50px;
    min-height: 100px;
}

.flex-list-row {
    display: flex;
}

.flex-list-column {
    display: flex;
    flex-direction: column;
}

.user-delete-input {
    padding: 7px 10px;
    min-width: 320px;
    border: 0.5px solid #ccc;
    border-radius: 3px;
}

.firebase-suppliers-list {
    margin-top: 20px;
}

.rw-widget-input, .rw-filter-input {
    box-shadow: none;
}

.rw-widget {
    width: 400px;
    float: left;
}

.rw-widget-container {
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
    border-color: #C9D6DE !important;
    box-shadow: none !important;
    cursor: text;
}

.rw-list-empty, .rw-list-option, .rw-list-optgroup {
    padding: 10px 20px;
}

.rw-list-option.rw-state-focus, .rw-list-option.rw-state-focus:hover {
    background-color: transparent;
    border-color: #C9D6DE;
    color: #333;
    border-left: none;
    border-right: none;
}

.remove-supplier {
    float: left;
    margin-left: 40px;
    min-width: 100px;
    border-radius: 0;
    padding: 8px 30px;
}

.add-user {
    min-width: 100px;
    border-radius: 0;
    padding: 8px 30px;
    margin: 10px 0 20px;
}

.user-edit-button {
    min-width: 100px;
    border-radius: 0;
    padding: 8px 30px;
    margin: 0 10px;
}

.add-new-admin {
    padding: 20px 0 10px;
    border: 1px solid #C9D6DE;
    margin-bottom: 30px;
}

.add-new-admin button, .popup-inline-popup {
    min-width: 140px;
    border-radius: 0;
    padding: 8px 30px;
    display: block;
    margin: 25px auto auto;
}

.firebase-password-reset {
    margin-top: 50px;
}

.supplier-search-container {
    position: relative;
}

.search-result {
    position: absolute;
    width: 350px;
    background: #fff;
    z-index: 1000;
    top: 100%;
}

.supplier-search-list {
    border: 1px solid #C9D6DE;
    border-top: none;
    max-height: 200px;
    overflow: auto;
}

.supplier-search-list li {
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    cursor: pointer;
    border-bottom: 1px solid #C9D6DE;
}

.supplier-search-list li:last-child {
    border-bottom: none;
}

.supplier-search-input {
    padding-right: 30px;
    display: inline-block;
    vertical-align: middle;
    width: 350px;
}

.supplier-search-button {
    display: inline-block;
    vertical-align: middle;
    margin-left: 15px;
}

.supplier-id-search {
    display: inline-block;
    vertical-align: middle;
}

.supplier-id-search .form-group {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 0;
}

.supplier-id-search .control-label {
    display: none;
}

.clear-search {
    position: absolute;
    left: 315px;
    top: 4px;
    cursor: pointer;
    line-height: 28px;
    width: 34px;
    height: 34px;
    text-align: center;
    font-size: 30px;
}

.password-generate-button {
    display: inline-block !important;
}

.firebase-selected-new-suppliers, .firebase-selected-suppliers {
    padding: 10px 0;
}

.firebase-selected-supplier {
    display: inline-block;
    vertical-align: middle;
    margin: 5px 10px 5px 0;
    border-radius: 4px;
    background-color: #C9D6DE;
    font-size: 14px;
}

.firebase-selected-supplier span {
    display: inline-block;
    vertical-align: middle;
    padding: 5px 10px;
}

.firebase-selected-supplier span.firebase-selected-supplier-name {
    padding-right: 0;
}

.firebase-selected-supplier span.firebase-selected-supplier-remove {
    cursor: pointer;
}

.submit-added-supplier {
    margin-top: 10px;
}

.medium-button {
    padding: 8px 15px;
    min-width: 130px;
}
`, "",{"version":3,"sources":["webpack://./client/components/styles/search-list.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,gCAAgC;IAChC,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":["#algolia-search {\n    position: relative;\n}\n\n.search-list {\n    display: none;\n    background-color: #FFFFFF;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    max-height: 300px;\n    z-index: 100;\n    overflow: scroll;\n    border: 1px solid #C9D6DE;\n    border-top: 0;\n    font-size: 14px;\n}\n\n.search-list li {\n    padding: 8px 10px;\n    border-bottom: 1px solid #C9D6DE;\n    cursor: pointer;\n}\n\n.search-list li:last-child {\n    border-bottom: 0;\n}\n\n.list-opened {\n    display: block;\n}\n\n.al-search-list-opened{\n    display: block;\n    width: 210px;\n    z-index: 1000000;\n    position: absolute;\n    top: 60px;\n    left: 52px;\n}\n\n.firebase-suppliers-view {\n    margin-top: 50px;\n    min-height: 300px;\n}\n\n.firebase-suppliers-view-two {\n    margin-top: 50px;\n    min-height: 100px;\n}\n\n.flex-list-row {\n    display: flex;\n}\n\n.flex-list-column {\n    display: flex;\n    flex-direction: column;\n}\n\n.user-delete-input {\n    padding: 7px 10px;\n    min-width: 320px;\n    border: 0.5px solid #ccc;\n    border-radius: 3px;\n}\n\n.firebase-suppliers-list {\n    margin-top: 20px;\n}\n\n.rw-widget-input, .rw-filter-input {\n    box-shadow: none;\n}\n\n.rw-widget {\n    width: 400px;\n    float: left;\n}\n\n.rw-widget-container {\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    border-radius: 0;\n    border-color: #C9D6DE !important;\n    box-shadow: none !important;\n    cursor: text;\n}\n\n.rw-list-empty, .rw-list-option, .rw-list-optgroup {\n    padding: 10px 20px;\n}\n\n.rw-list-option.rw-state-focus, .rw-list-option.rw-state-focus:hover {\n    background-color: transparent;\n    border-color: #C9D6DE;\n    color: #333;\n    border-left: none;\n    border-right: none;\n}\n\n.remove-supplier {\n    float: left;\n    margin-left: 40px;\n    min-width: 100px;\n    border-radius: 0;\n    padding: 8px 30px;\n}\n\n.add-user {\n    min-width: 100px;\n    border-radius: 0;\n    padding: 8px 30px;\n    margin: 10px 0 20px;\n}\n\n.user-edit-button {\n    min-width: 100px;\n    border-radius: 0;\n    padding: 8px 30px;\n    margin: 0 10px;\n}\n\n.add-new-admin {\n    padding: 20px 0 10px;\n    border: 1px solid #C9D6DE;\n    margin-bottom: 30px;\n}\n\n.add-new-admin button, .popup-inline-popup {\n    min-width: 140px;\n    border-radius: 0;\n    padding: 8px 30px;\n    display: block;\n    margin: 25px auto auto;\n}\n\n.firebase-password-reset {\n    margin-top: 50px;\n}\n\n.supplier-search-container {\n    position: relative;\n}\n\n.search-result {\n    position: absolute;\n    width: 350px;\n    background: #fff;\n    z-index: 1000;\n    top: 100%;\n}\n\n.supplier-search-list {\n    border: 1px solid #C9D6DE;\n    border-top: none;\n    max-height: 200px;\n    overflow: auto;\n}\n\n.supplier-search-list li {\n    padding: 6px 12px;\n    font-size: 14px;\n    line-height: 1.42857143;\n    cursor: pointer;\n    border-bottom: 1px solid #C9D6DE;\n}\n\n.supplier-search-list li:last-child {\n    border-bottom: none;\n}\n\n.supplier-search-input {\n    padding-right: 30px;\n    display: inline-block;\n    vertical-align: middle;\n    width: 350px;\n}\n\n.supplier-search-button {\n    display: inline-block;\n    vertical-align: middle;\n    margin-left: 15px;\n}\n\n.supplier-id-search {\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.supplier-id-search .form-group {\n    display: inline-block;\n    vertical-align: middle;\n    margin-bottom: 0;\n}\n\n.supplier-id-search .control-label {\n    display: none;\n}\n\n.clear-search {\n    position: absolute;\n    left: 315px;\n    top: 4px;\n    cursor: pointer;\n    line-height: 28px;\n    width: 34px;\n    height: 34px;\n    text-align: center;\n    font-size: 30px;\n}\n\n.password-generate-button {\n    display: inline-block !important;\n}\n\n.firebase-selected-new-suppliers, .firebase-selected-suppliers {\n    padding: 10px 0;\n}\n\n.firebase-selected-supplier {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 5px 10px 5px 0;\n    border-radius: 4px;\n    background-color: #C9D6DE;\n    font-size: 14px;\n}\n\n.firebase-selected-supplier span {\n    display: inline-block;\n    vertical-align: middle;\n    padding: 5px 10px;\n}\n\n.firebase-selected-supplier span.firebase-selected-supplier-name {\n    padding-right: 0;\n}\n\n.firebase-selected-supplier span.firebase-selected-supplier-remove {\n    cursor: pointer;\n}\n\n.submit-added-supplier {\n    margin-top: 10px;\n}\n\n.medium-button {\n    padding: 8px 15px;\n    min-width: 130px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
